import script from "./BpmnFlow.vue?vue&type=script&setup=true&lang=js"
export * from "./BpmnFlow.vue?vue&type=script&setup=true&lang=js"

import "./BpmnFlow.vue?vue&type=style&index=0&id=6cfcaa50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cfcaa50"]])

export default __exports__